import { render, staticRenderFns } from "./CartasRespostaCriar.vue?vue&type=template&id=de3f9bf8"
import script from "./CartasRespostaCriar.vue?vue&type=script&lang=js"
export * from "./CartasRespostaCriar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports